var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrailer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    transform: "scale(-1, 1)",
    "transform-origin": "center",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 12,
    fill: "#F6F9F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.1797 26.5466C36.7266 26.5466 36.3593 26.9139 36.3593 27.367V28.251H35.1389V13.9141C35.1389 13.461 34.7717 13.0938 34.3186 13.0938H14.1017C11.84 13.0938 10 14.9338 10 17.1954V30.402C10 30.855 10.3673 31.2223 10.8203 31.2223H13.3704C13.4452 33.2678 15.1316 34.9091 17.195 34.9091C19.2585 34.9091 20.9449 33.2678 21.0197 31.2223H29.67V32.9941C29.67 33.4471 30.0373 33.8144 30.4903 33.8144C30.9434 33.8144 31.3107 33.4471 31.3107 32.9941V31.2223H34.3186C34.7717 31.2223 35.1389 30.855 35.1389 30.402V29.8916H37.1797C37.6327 29.8916 38 29.5243 38 29.0712V27.3669C38 26.9139 37.6327 26.5466 37.1797 26.5466ZM19.4736 24.2225V20.623H25.6656V24.2225H19.4736ZM11.6407 24.2225V20.623H17.8329V24.2225H11.6407ZM27.3062 20.6229H33.4983V24.2224H27.3062V20.6229ZM14.1017 14.7344H33.4983V18.9823H11.6407V17.1954C11.6407 15.8384 12.7447 14.7344 14.1017 14.7344ZM17.195 33.2685C16.0364 33.2685 15.0857 32.3629 15.0126 31.2224H19.3776C19.3043 32.3629 18.3537 33.2685 17.195 33.2685ZM33.4983 29.5817H11.6407V25.8631H33.4983V29.5817Z",
    fill: ""
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrailer);
export default __webpack_public_path__ + "static/media/trailer.7e2ca9084266433612229126a6fc9c31.svg";
export { ForwardRef as ReactComponent };